import React from 'react';
import { useTranslation } from 'react-i18next';

const containerStyle = {
  padding: '20px',
  textAlign: 'center'
};

const descriptionStyle = {
  marginTop: '8px'
};

export default function GraphPlaceholderView() {
  const { t } = useTranslation();

  return (
    <section style={containerStyle} aria-labelledby="records-graph-placeholder-title">
      <h2 id="records-graph-placeholder-title">{t('records.views.graph.title')}</h2>
      <p style={descriptionStyle}>{t('records.views.graph.coming_soon')}</p>
    </section>
  );
}
